import axios from 'axios'

export default {
  namespaced: true,
  state: {
    codes: [],
    count: 0
  },
  mutations: {
    SET_CODES (state, codes) {
      state.codes = codes
    },
    SET_COUNT (state, count) {
      state.count = count
    }
  },
  getters: {},
  actions: {
    async get ({ commit }, { status, params }) {
      commit('SET_CODES', [])
      let codes = await axios.get(`/codes/${status}`, { params })
      let count = await axios.get(`/codes/${status}/count`, { params })
      commit('SET_CODES', codes.data)
      commit('SET_COUNT', count.data)
    },

    async create ({ commit }, data) {
      return axios.post('/codes', data)
    },

    async update ({ commit }, { id, data }) {
      return axios.patch(`/codes/${id}`, data)
    },

    async delete ({ commit }, ids) {
      let result
      for (let a = 0; a < ids.length; a++) {
        result = await axios.delete(`/codes/${ids[a]}`)
      }
      return result
    },

    async recover ({ commit }, codes) {
      let result
      for (let a = 0; a < codes.length; a++) {
        result = await axios
          .patch(`/codes/${codes[a].id}/restore`, codes[a].data)
      }
      return result
    },

    async archive ({ commit }) {
      let result = await axios.get('/codes/archive')

      commit('SET_CODES', result.data)
    }
  }
}
